import { Box } from '@mui/material'
import MarkdownLink from './MarkdownLink'
import { withCitations } from './withCitations'

/**
 * Inline overrides. Each applies `withCitations` to its own text children so a
 * marker inside `**bold [1]**` still becomes a CitationMarker.
 */
export function inlineComponents(citations) {
  const cite = (children, key) => withCitations(children, citations, key)

  return {
    strong: ({ children }) => (
      <Box component="strong" sx={{ fontWeight: 'var(--app-agent-result-font-weight-medium)' }}>{cite(children, 'strong')}</Box>
    ),
    em: ({ children }) => (
      <Box component="em" sx={{ fontStyle: 'italic' }}>{cite(children, 'em')}</Box>
    ),
    del: ({ children }) => <Box component="del">{cite(children, 'del')}</Box>,
    a: MarkdownLink,
  }
}
